import { EditHistory, EditHistoryOperation } from '../types';
import { apiClient } from './api';

interface EditHistoryResponse {
  data: EditHistory;
}
interface UndoRedoResponse {
  data: EditHistoryOperation;
}

class EditHistoryService {
  private baseUrl = '/transcripts';

  async getEditHistory(audioFileId: string): Promise<EditHistory> {
    const response = await apiClient.get<EditHistoryResponse>(
      `${this.baseUrl}/${audioFileId}/edit-history`
    );
    return response.data.data;
  }

  async undo(audioFileId: string): Promise<EditHistoryOperation> {
    const response = await apiClient.post<UndoRedoResponse>(
      `${this.baseUrl}/${audioFileId}/edit-history/undo`
    );
    return response.data.data;
  }

  async redo(audioFileId: string): Promise<EditHistoryOperation> {
    const response = await apiClient.post<UndoRedoResponse>(
      `${this.baseUrl}/${audioFileId}/edit-history/redo`
    );
    return response.data.data;
  }
}

export const editHistoryService = new EditHistoryService();
